// Module
var code = "<am-deck data-test-id=\"app-deck\"></am-deck>\n<topbar data-test-id=\"app-topbar\" />\n<menubar ng-class=\"{ open: menuOpen }\" data-test-id=\"app-menubar\" />\n<ui-view id=\"content-view\" class=\"flexible-container\" data-test-id=\"app-content-view\" />";
// Exports
module.exports = code;